export function parseDate(
  date: string,
  convertToLocal: boolean = true,
  time: boolean = true,
): string {
  if (!date) return ''

  const dateObj = new Date(date)

  if (!convertToLocal) {
    const iso = dateObj.toISOString().replace('T', ' ')
    return time ? iso.slice(0, 16) : iso.slice(0, 10)
  }

  const options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    ...(time && {
      hour: '2-digit',
      minute: '2-digit',
    }),
  }

  const localized = dateObj.toLocaleDateString('en-US', options)

  if (time) {
    return (
      localized.substring(0, 10) +
      ' - ' +
      localized.substring(localized.length - 8)
    )
  }

  return localized.substring(0, 10)
}

export const convertTime12toSeconds = (
  initialHours,
  minutes,
  modifier,
  trueSeconds,
) => {
  let hours = Number(initialHours)
  if (hours === 12) {
    hours = 0
  }
  if (modifier === 'PM') {
    hours = parseInt(hours, 10) + 12
  }
  if (trueSeconds) return (hours * 60 + Number(minutes)) * 60000
  return new Date((hours * 60 + Number(minutes)) * 60000)
}
